import React from "react";
import { Card, Col, Typography } from "antd";
import { getFullName } from "../../careprovider/visits/utils";
import { getUserAge } from "../../../utils/userdatautils";
import "./reportingLogDataList.css";

const { Text } = Typography;

const formatGender = (gender) =>
  gender ? `${gender.charAt(0)}${gender.slice(1).toLowerCase()}` : null;

const formatDob = (birthDate) =>
  birthDate ? new Date(birthDate).toLocaleDateString() : null;

const VolunteerCardRow = ({ label, value, ellipsis }) => (
  <div className="reporting-volunteer-card__row">
    <Text
      type="secondary"
      className={label ? "reporting-volunteer-card__label" : undefined}
    >
      {label}
    </Text>
    <Text strong type="secondary" ellipsis={ellipsis}>
      {value}
    </Text>
  </div>
);

const VolunteerCard = ({ item, index, onNavigate, isPatient }) => {
  const fullName = getFullName(item?.givenName, item?.familyName);
  const age =
    item?.birthDate && !isNaN(getUserAge(item?.birthDate))
      ? getUserAge(item?.birthDate)
      : null;
  const genderLabel = formatGender(item?.gender);
  const metaParts = [
    genderLabel,
    age != null ? `Age ${age}` : null,
  ].filter(Boolean);
  const profileIdentifier = item?.userIdentifier ?? item?.workforceIdentifier;

  const handleClick = () => {
    if (profileIdentifier) onNavigate(profileIdentifier);
  };

  return (
    <Col
      xs={24}
      sm={24}
      key={item?.workforceIdentifier ?? item?.userIdentifier ?? index}
    >
      <Card className="reporting-volunteer-card">
        <div className="reporting-volunteer-card__header">
          <div className="reporting-volunteer-card__title-wrap">
            <Text
              strong
              className="reporting-volunteer-card__name"
              ellipsis={{ tooltip: fullName }}
              onClick={handleClick}
            >
              {fullName || "—"}
              {isPatient && item?.medicalRecordNumber != null && (
                <span className="reporting-volunteer-card__mrn">
                  {" "}
                  (MRN: {item.medicalRecordNumber})
                </span>
              )}
            </Text>
            {metaParts.length > 0 && (
              <Text
                strong
                type="secondary"
                className="reporting-volunteer-card__meta"
              >
                {metaParts.join(", ")}
              </Text>
            )}
          </div>
        </div>
        <div className="reporting-volunteer-card__body">
          {item?.email && (
            <VolunteerCardRow
              label="Email:"
              value={item.email}
              ellipsis={{ tooltip: item.email }}
            />
          )}
          {(item?.telephone || item?.phone) && (
            <VolunteerCardRow
              label="Phone:"
              value={item?.telephone || item?.phone}
            />
          )}
          {item?.birthDate && (
            <VolunteerCardRow
              label="DOB:"
              value={formatDob(item.birthDate)}
            />
          )}
        </div>
      </Card>
    </Col>
  );
};

export default VolunteerCard;
